/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */
// eslint-disable-next-line
// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'


// Store functionality
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
import state from './state'

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage
})


Vue.use(Vuex,vuexLocal)

// Create a new store
const store = new Vuex.Store({
   plugins: [vuexLocal.plugin],
  actions,
  getters,
  modules,
  mutations,
  state
})

//socket.io
import socketio from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
import config from '@/config';
const socket = socketio(config.socket) //config.socket
socket.on('connect', function(){
  store.dispatch('auth/authenticate')
});
var VS = new VueSocketIO({
    debug: false,
    connection: socket,
    vuex: {
        store,
        actionPrefix: 'socket_',
        mutationPrefix: 'socket_'
    }
});

Vue.use(VS)

var bus = new Vue({})// This empty Vue model will serve as our event
store.$bus = bus
store.$socket = socket
//Vue.prototype.$bus = bus // Global event bus
//Vue.prototype.$settings = store.getters['auth/settings'] //global settings
 
Object.defineProperty(Vue.prototype, "$bus", {////gGlobal event bus
  get() {
    return bus;
  }
});
 
Vue.mixin({
      created: function () { //add option "$bus" instead bus.$on in created hook
        var self = this, name
        var $bus = this.$options.$bus
        this.$busListeners = {}
        for (name in $bus) {
          this.$busListeners[name] = $bus[name].bind(this) //rebind and remember each declared listener
          bus.$on(name, this.$busListeners[name]) //register a listener for the event
        }
        var $data = this.$options.$data
          for (name in $data) {
          let options = $data[name]
          bus.$on('ready', function(arg) {
            bus.sockets.subscribe(options.callback, (response) => {
              bus.sockets.unsubscribe(options.callback);
              self[name] = response.data
            });
            socket.emit(options.callback, options)
          })
         
        }
      },
      filters: {
        subStr: function(string, length) {
          if (!length) length = 50
            if (!string) return ''
              return string.substring(0,length) + '...';
            }
        },
      beforeDestroy: function () { //unreg listeners
        for (var name in this.$busListeners) bus.$off(name, this.$busListeners[name])
        this.$busListeners = null
      }
    })
 
 
Object.defineProperty(Vue.prototype, "$settings", {////global settings
  get() {
    return store.getters['auth/settings'];
  }
});
export default store